customElements.get("tool-tip") || customElements.define("tool-tip", class extends HTMLElement {
  constructor() {
    super(), this.textElement = this.querySelector("[data-tooltip-text]"), this.clonedTooltip = null, 
    this.handleME = this.handleME.bind(this), this.handleML = this.handleML.bind(this), 
    this.handleMouseMove = this.handleMouseMove.bind(this);
  }
  handleME(t) {
    this.clonedTooltip.style.opacity = "1";
  }
  handleML(t) {
    this.clonedTooltip && (this.clonedTooltip.style.opacity = "0");
  }
  handleMouseMove(t) {
    if (!this.clonedTooltip) return;
    const e = this.getBoundingClientRect(), o = t.clientX - e.left, l = t.clientY - e.top, i = e.left + o + 10, s = e.top + l + 10;
    this.clonedTooltip.style.transform = `translate(${i}px, ${s}px)`;
  }
  connectedCallback() {
    this.textElement && (this.addEventListener("mouseenter", this.handleME), this.addEventListener("mouseleave", this.handleML), 
    this.addEventListener("mousemove", this.handleMouseMove), this.clonedTooltip || (this.clonedTooltip = this.textElement.cloneNode(!0), 
    this.clonedTooltip.classList.add("tool-tip-clone"), this.clonedTooltip.classList.remove("sr-only"), 
    this.clonedTooltip.classList.add("tool-tip"), this.clonedTooltip.style.position = "fixed", 
    this.clonedTooltip.style.top = "0", this.clonedTooltip.style.left = "0", this.clonedTooltip.style.pointerEvents = "none", 
    this.clonedTooltip.style.zIndex = "9999", this.clonedTooltip.style.opacity = "0", 
    document.body.appendChild(this.clonedTooltip)));
  }
  disconnectedCallback() {
    this.textElement && (this.removeEventListener("mouseenter", this.handleME), this.removeEventListener("mouseleave", this.handleML), 
    this.removeEventListener("mousemove", this.handleMouseMove), this.clonedTooltip && this.clonedTooltip.parentNode && (document.body.removeChild(this.clonedTooltip), 
    this.clonedTooltip = null));
  }
});